import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from "react-on-screen";
import ScrollAnimation from "react-animate-on-scroll";

const Data = [
    {
        countNum : 30000,
        countTitle: 'Travel Agencies',
    },
    {
        countNum : 120,
        countTitle: 'Member Countries',
    },
];
const SlipFour = () => {
    return (
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="order-2 order-lg-1 col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h4 className="title" style={{color:"#212170"}}>Universal Federation of Travel Agents Association </h4> <p>is an association of travel agents and tour operators. It is one of the largest organizations in the field of travel and tourism industry.UFTAA effectively represents Travel Agents and Tour Operators views on both Inbound and Outbound travel by continuous dialogue and consultation with other international organisations such as the International Air Transport Association (IATA), the International Hotel and Restaurant Association (IH&RA), the International Union of Railways (IUR), the International Road Union (IRU) and the International Chamber of Commerce (ICC) to mention only a few.

UFTAA has consultative status with the UN/NGO/ECOSOC, and works closely with other world bodies such as UNESCO, WHO etc. for a sustainable and responsible tourism. UFTAA is an affiliate member of the World Tourism Organisation (WTO) and its Business Council (WTOBC).</p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">UFTAA is called as one of the principal organizations/associations of the travel agent at global. Its membership is open to all national travel agents, associations such as TAAI, AATTA, and EATTA.</p>
                                <h5 className="title" style={{color:"#212170", fontSize:"26px"}}>The main objective of the association is the promotion, development, and expansion of the travel and tourism industry worldwide. </h5> 
                            </ScrollAnimation>

                            <div className="row">
                                {Data.map((data, index) => (
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={index}>
                                        <div className="count-box counter-style-4 text-start">
                                            <TrackVisibility once>
                                                {({ isVisible }) => isVisible && 
                                                    <div className="count-number">{isVisible ? <CountUp end={data.countNum} /> : 0}</div>}
                                            </TrackVisibility>
                                            <h5 className="counter-title">{data.countTitle}</h5>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="order-1 order-lg-2 col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail">
                            <img src="./images/bg/uftaa6.jpeg" alt="split Images" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SlipFour;